const setQueryToUrl = (url: string | undefined) => {
  const urlParams = new URLSearchParams(window.location.search);
  const newUrlParams = new URLSearchParams();

  urlParams.forEach((value, key) => {
    if (!key.startsWith('sirena_')) {
      newUrlParams.set(key, value);
    }
  });

  const queryString = newUrlParams.toString();
  const additional = queryString ? `?${queryString}` : '';

  return `${url}${additional}`;
};

export default setQueryToUrl;
